module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-prompt"
  }, [(_vm.state === 'pre') ? _c('div', {
    on: {
      "click": _vm.prompt
    }
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.state === 'prompt') ? _c('form', {
    staticClass: "u-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.complete($event)
      }
    }
  }, [_c('span', {
    staticClass: "input-prompt-label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "u-input",
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.cancel($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "u-button u-button-primary",
    on: {
      "click": _vm.complete
    }
  }, [_vm._v(_vm._s(_vm.$t('ok')))]), _vm._v(" "), _c('a', {
    staticClass: "u-button u-button-secondary",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-566c0cb5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/InputPrompt.vue
// module id = 488
// module chunks = 2